module.exports = __webpack_public_path__ + "static/media/Flood_Alert_small.00ef7fb8.png";